import React from "react";
import Sidebar from "./Sidebar";
import BottomNav from "./BottomNav";
import MobileHeader from "./MobileHeader";
import type { View } from "../../types";

interface AppLayoutProps {
    children: React.ReactNode;
    view: View;
    setView: (view: View) => void;
    setIsSettingsOpen: (isOpen: boolean) => void;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children, view, setView, setIsSettingsOpen }) => {
    return (
        <div className="relative flex min-h-screen">
            <MobileHeader />
            <Sidebar view={view} setView={setView} setIsSettingsOpen={setIsSettingsOpen} />
            <BottomNav view={view} setView={setView} setIsSettingsOpen={setIsSettingsOpen} />
            <main className="flex-1 p-4 md:p-8 lg:p-12 w-full z-10 overflow-x-hidden pt-20 md:pt-8 md:pb-8 pb-24">
                {children}
            </main>
        </div>
    );
};

export default AppLayout;
